module.exports = __webpack_public_path__ + "media/components/assets/img/icons/airplane-f5100220bc6c3dd567c9abd8aeab67cf.svg";